export default "__VITE_ASSET__c544faf5__"